module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "message-template"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addTemplatesDialogVisible()
      }
    }
  }, [_vm._v("添加模板")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择app"
    },
    on: {
      "change": function($event) {
        return _vm.reloadList()
      }
    },
    model: {
      value: (_vm.appid),
      callback: function($$v) {
        _vm.appid = $$v
      },
      expression: "appid"
    }
  }, _vm._l((_vm.appid_data), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"
    },
    attrs: {
      "height": "650px",
      "data": _vm.temlateList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "模板名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "template_id",
      "label": "模板id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "scenes_name",
      "label": "模板别名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_open",
      "label": "是否禁用",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_open == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已启用")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已禁用")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "send_time_desc",
      "label": "发送时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.editTemplatesDialogVisible(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.tmpl_type == 'nowSend') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.sendMsg(scope.row)
            }
          }
        }, [_vm._v("推送")]) : _vm._e()]
      }
    }])
  })], 1)], _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded block",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.page,
      "page-sizes": [10, 20, 50, 100],
      "total": _vm.total_count,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.reloadList
    }
  })], 1)], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加消息模版",
      "size": "tiny",
      "visible": _vm.addTemplateDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addTemplateDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    ref: "addTemplate",
    attrs: {
      "label-width": "125px",
      "model": _vm.addTemplate
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板名称",
      "rules": {
        required: true
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入模板名称"
    },
    model: {
      value: (_vm.addTemplate.title),
      callback: function($$v) {
        _vm.$set(_vm.addTemplate, "title", $$v)
      },
      expression: "addTemplate.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板id",
      "rules": {
        required: true
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入模板id"
    },
    model: {
      value: (_vm.addTemplate.template_id),
      callback: function($$v) {
        _vm.$set(_vm.addTemplate, "template_id", $$v)
      },
      expression: "addTemplate.template_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板别名",
      "rules": {
        required: true
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入模板别名"
    },
    model: {
      value: (_vm.addTemplate.scenes_name),
      callback: function($$v) {
        _vm.$set(_vm.addTemplate, "scenes_name", $$v)
      },
      expression: "addTemplate.scenes_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消息类型",
      "rules": {
        required: true
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addTemplate.tmpl_type),
      callback: function($$v) {
        _vm.$set(_vm.addTemplate, "tmpl_type", $$v)
      },
      expression: "addTemplate.tmpl_type"
    }
  }, _vm._l((_vm.tmpl_type_data), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小程序app",
      "rules": {
        required: true
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择app"
    },
    model: {
      value: (_vm.addTemplate.appid),
      callback: function($$v) {
        _vm.$set(_vm.addTemplate, "appid", $$v)
      },
      expression: "addTemplate.appid"
    }
  }, _vm._l((_vm.appid_data), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.addTemplate.is_open),
      callback: function($$v) {
        _vm.$set(_vm.addTemplate, "is_open", $$v)
      },
      expression: "addTemplate.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发送时间点",
      "rules": {
        required: true
      }
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.addTemplate.send_time_desc),
      callback: function($$v) {
        _vm.$set(_vm.addTemplate, "send_time_desc", $$v)
      },
      expression: "addTemplate.send_time_desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板内容"
    }
  }, [_vm._l((_vm.addTemplate.content), function(data) {
    return _c('div', {
      key: data.column
    }, [_c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('el-input', {
      staticClass: "tempalteTag",
      attrs: {
        "placeholder": "请输入键值名称例如thing1,thing2"
      },
      model: {
        value: (data.keyName),
        callback: function($$v) {
          _vm.$set(data, "keyName", $$v)
        },
        expression: "data.keyName"
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "tempalteTag",
      attrs: {
        "placeholder": "请输入文案内容"
      },
      model: {
        value: (data.keyValue),
        callback: function($$v) {
          _vm.$set(data, "keyValue", $$v)
        },
        expression: "data.keyValue"
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.delAddKeyValue(data)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addTemplateTag
    }
  }, [_vm._v("添加")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小程序跳转页面"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入跳转页面链接"
    },
    model: {
      value: (_vm.addTemplate.page),
      callback: function($$v) {
        _vm.$set(_vm.addTemplate, "page", $$v)
      },
      expression: "addTemplate.page"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitData
    }
  }, [_vm._v("确认添加")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "小程序消息模版编辑",
      "size": "tiny",
      "visible": _vm.editTemplateDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editTemplateDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "125px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板名称",
      "rules": {
        required: true
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入模板名称"
    },
    model: {
      value: (_vm.editTemplate.title),
      callback: function($$v) {
        _vm.$set(_vm.editTemplate, "title", $$v)
      },
      expression: "editTemplate.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板id",
      "rules": {
        required: true
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入模板id",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.editTemplate.template_id),
      callback: function($$v) {
        _vm.$set(_vm.editTemplate, "template_id", $$v)
      },
      expression: "editTemplate.template_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板别名",
      "rules": {
        required: true
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入模板别名",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.editTemplate.scenes_name),
      callback: function($$v) {
        _vm.$set(_vm.editTemplate, "scenes_name", $$v)
      },
      expression: "editTemplate.scenes_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消息类型",
      "rules": {
        required: true
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editTemplate.tmpl_type),
      callback: function($$v) {
        _vm.$set(_vm.editTemplate, "tmpl_type", $$v)
      },
      expression: "editTemplate.tmpl_type"
    }
  }, _vm._l((_vm.tmpl_type_data), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小程序app",
      "rules": {
        required: true
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择app"
    },
    model: {
      value: (_vm.editTemplate.appid),
      callback: function($$v) {
        _vm.$set(_vm.editTemplate, "appid", $$v)
      },
      expression: "editTemplate.appid"
    }
  }, _vm._l((_vm.appid_data), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.editTemplate.is_open),
      callback: function($$v) {
        _vm.$set(_vm.editTemplate, "is_open", $$v)
      },
      expression: "editTemplate.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发送时间点",
      "rules": {
        required: true
      }
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.editTemplate.send_time_desc),
      callback: function($$v) {
        _vm.$set(_vm.editTemplate, "send_time_desc", $$v)
      },
      expression: "editTemplate.send_time_desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板内容"
    }
  }, [_vm._l((_vm.editTemplate.content), function(data) {
    return _c('div', {
      key: data.column
    }, [_c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('el-input', {
      staticClass: "tempalteTag",
      attrs: {
        "placeholder": "请输入键值名称例如thing1,thing2"
      },
      model: {
        value: (data.keyName),
        callback: function($$v) {
          _vm.$set(data, "keyName", $$v)
        },
        expression: "data.keyName"
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "tempalteTag",
      attrs: {
        "placeholder": "请输入文案内容"
      },
      model: {
        value: (data.keyValue),
        callback: function($$v) {
          _vm.$set(data, "keyValue", $$v)
        },
        expression: "data.keyValue"
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.delEditKeyValue(data)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.editTemplateTag
    }
  }, [_vm._v("添加")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小程序跳转页面"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入跳转页面链接"
    },
    model: {
      value: (_vm.editTemplate.page),
      callback: function($$v) {
        _vm.$set(_vm.editTemplate, "page", $$v)
      },
      expression: "editTemplate.page"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("确认修改")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36e18264", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36e18264"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/messages.vue
// module id = 2612
// module chunks = 0